import { atom, useAtom } from 'jotai';

// array for the chat windows
const tabs = [
  // {
  //   id: '0',
  //   radio: 'radio-1',
  //   intent: 'PromtData',
  //   label: 'data',
  //   icon: 'database'
  // },
  {
    id: '1',
    radio: 'radio-2',
    intent: 'PromtEmbeddings',
    label: 'documents',
    icon: 'description'
  }
  // Add more tabs items as needed
];
export const tabsAtom = atom(tabs);

export function useTabsAtom() {
  return useAtom(tabsAtom);
}
